import { Box, TextField } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import {
  updatePlaylistPowerUserThreshold,
  updatePlaylistPowerUserWelcomeMessage,
} from "../app/configSlice";

function MiscPage() {
  const dispatch = useDispatch();
  const playlistPowerUserThreshold = useSelector(
    (state) => state.config.playlistPowerUserThreshold
  );
  const playlistPowerUser_welcomeMessage = useSelector(
    (state) => state.config.playlistPowerUser_welcomeMessage
  );

  const textFieldStyle = {
    mt: 2,
    backgroundColor: "white",
  }

  return (
    <Box>
      <h1>Misc</h1>
      <TextField
        label="Playlist power user threshold"
        defaultValue={playlistPowerUserThreshold}
        sx={{ width: 1 / 4, backgroundColor: "white" }}
        onChange={(e) =>
          dispatch(updatePlaylistPowerUserThreshold(e.target.value))
        }
      />
      <TextField
        label="Playlist power user welcome message"
        multiline
        fullWidth
        sx={textFieldStyle}
        defaultValue={playlistPowerUser_welcomeMessage}
        onChange={(e) =>
          dispatch(updatePlaylistPowerUserWelcomeMessage(e.target.value))
        }
      />
    </Box>
  );
}

export default MiscPage;
